import { render, staticRenderFns } from "./OPPendingDetailComponent.vue?vue&type=template&id=08a4992d&"
import script from "./OPPendingDetailComponent.vue?vue&type=script&lang=js&"
export * from "./OPPendingDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports